/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
declare const _matricesPanel_value$ref: unique symbol;
export type matricesPanel_value$ref = typeof _matricesPanel_value$ref;
export type matricesPanel_value = {
    readonly description: string | null;
    readonly label: string | null;
    readonly lists: ReadonlyArray<{
        readonly __typename: string;
        readonly id?: string;
        readonly previews?: {
            readonly count: number | null;
            readonly edges: ReadonlyArray<{
                readonly cursor: string | null;
                readonly preview: {
                    readonly link: string | null;
                    readonly mediaAsset: {
                        readonly id: string;
                        readonly files: ReadonlyArray<{
                            readonly id: string;
                            readonly name: string | null;
                            readonly path: string | null;
                        }> | null;
                        readonly topLevelMediaType: {
                            readonly kind: TopLevelMediaKind | null;
                            readonly label: string | null;
                        } | null;
                    } | null;
                    readonly kind: PreviewKind | null;
                } | null;
            }> | null;
        } | null;
        readonly name?: string | null;
        readonly label?: string | null;
        readonly title?: string | null;
        readonly description?: string | null;
        readonly subTitle?: string | null;
    } & ({
        readonly __typename: "DynamicList";
        readonly id: string;
    } | {
        readonly __typename: "FixedList";
        readonly previews: {
            readonly count: number | null;
            readonly edges: ReadonlyArray<{
                readonly cursor: string | null;
                readonly preview: {
                    readonly link: string | null;
                    readonly mediaAsset: {
                        readonly id: string;
                        readonly files: ReadonlyArray<{
                            readonly id: string;
                            readonly name: string | null;
                            readonly path: string | null;
                        }> | null;
                        readonly topLevelMediaType: {
                            readonly kind: TopLevelMediaKind | null;
                            readonly label: string | null;
                        } | null;
                    } | null;
                    readonly kind: PreviewKind | null;
                } | null;
            }> | null;
        } | null;
        readonly name: string | null;
        readonly label: string | null;
        readonly title: string | null;
        readonly description: string | null;
        readonly subTitle: string | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })> | null;
    readonly " $refType": matricesPanel_value$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "matricesPanel_value",
  "type": "ListCollection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "lists",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "type": "DynamicList",
          "selections": [
            (v2/*: any*/)
          ]
        },
        {
          "kind": "InlineFragment",
          "type": "FixedList",
          "selections": [
            (v2/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "previews",
              "storageKey": null,
              "args": null,
              "concreteType": "PreviewsConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "count",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PreviewEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "cursor",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "preview",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Preview",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "link",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "mediaAsset",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "MediaAsset",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "files",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "MediaAssetFile",
                              "plural": true,
                              "selections": [
                                (v2/*: any*/),
                                (v3/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "path",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "topLevelMediaType",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "TopLevelMediaType",
                              "plural": false,
                              "selections": [
                                (v4/*: any*/),
                                (v1/*: any*/)
                              ]
                            }
                          ]
                        },
                        (v4/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            (v3/*: any*/),
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "subTitle",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'ece786ec39cd69198310d53111f0f10f';
export default node;
